// eslint-disable-next-line no-restricted-imports
import { ModalCloseButton, ModalCloseButtonProps } from "@chakra-ui/react";
import { IconClose } from "src/components/icons";

export const WfModalCloseButton = (props: ModalCloseButtonProps) => (
    <ModalCloseButton {...props}>
        <IconClose boxSize={3} />
    </ModalCloseButton>
);
